import request from "@ali/request-olympics";
import { govMointor } from "@aligov/error-monitor";

class SubmitManager {
  constructor({
    fieldApi,
    context,
    url,
    params,
    endpoint,
    scrollManager,
    errorManager,
  }) {
    this.fieldApi = fieldApi;
    this.context = context;
    this.url = url;
    this.params = params;
    this.endpoint = endpoint;
    this.requestCounter = 0;
    this.retryTimes = 0;
    this.scrollManager = scrollManager;
    this.errorManager = errorManager;
  }

  get requestParams() {
    let { config } = this.params;
    const { viewId } = this.params;
    if (typeof config === "string") {
      config = JSON.parse(config);
    }
    return {
      ...this.params,
      viewId: viewId || (config && config.viewId),
      endpoint: this.endpoint || "online",
    };
  }

  updateRequestCounter = (flag) => {
    if (flag) {
      this.requestCounter += 1;
    } else if (this.requestCounter > 0) {
      this.requestCounter -= 1;
    }
  };

  savePage(fieldIds) {
    const formData = this.fieldApi.getFieldsData({
      fieldIds,
    });

    return new Promise((resolve, reject) => {
      if (!formData.success) {
        this.scrollManager.updateGroupError(formData);
        return resolve(formData);
      }

      return resolve(
        this.save({
          actionCode: "ValidateFormData",
          mode: "step",
          validateFieldIdList: Object.keys(formData.content).map((key) => key),
        })
      );
    });
  }

  save(params = {}) {
    if (this.requestCounter > 0) {
      return new Promise((resolve) => {
        setTimeout(resolve, 1000);
      }).then(this.save.bind(this, params));
    }
    const { actionCode, draft, mode, validateFieldIdList, matterId, url } =
      params;
    const formData = this.fieldApi.getFieldsData({
      disableValid: !!draft || mode === "step",
    });
    return new Promise((resolve, reject) => {
      if (!draft && !formData.success) {
        let success = false;
        if (
          mode === "step" &&
          (!formData.errorMsg || formData.errorMsg.length === 0)
        ) {
          success = true;
        }
        if (!success) {
          this.scrollManager.updateGroupError(formData);
          this.errorManager.updateFormErrors({ validateFieldIdList });
        }
        return resolve({
          success,
          errorMsg: formData.errorMsg || [],
        });
      }
      const requestParams = this.requestParams;
      const expandParam = {};
      if (mode === "step") {
        Object.assign(expandParam, {
          validateFieldIdList: validateFieldIdList || [],
        });
      }
      if (matterId) {
        Object.assign(expandParam, {
          curMatterId: matterId,
        });
      }
      const apiPath = url || this.url;
      const postData = {
        ...requestParams, // 兼容params里其它值传入
        // 这里可能有隐藏 bug，字符串转换成数字超过一定长度就会跪掉
        matterId: requestParams.matterId,
        actionCode,
        draft,
        data: JSON.stringify(formData.content),
        expandParam,
      };

      request(apiPath, {
        method: "POST",
        type: "",
        contentType: "application/json",
        headers: {
          access_token: requestParams.access_token || "",
          auth_type: requestParams.auth_type || "",
        },
        data: postData,
      })
        .then((res) => {
          const { success, traceId, extraData, ...others } = res || {};
          govMointor.api(
            apiPath,
            success,
            0,
            success ? "success" : "fail",
            JSON.stringify({ ...postData, traceId })
          );
          if (success) {
            this.scrollManager.updateGroupError({ success: true });
            this.errorManager.updateFormErrors({ validateFieldIdList });
            this.context.setGlobal({ hasSaved: true });
            return resolve({
              success: true,
              formData,
              response: res,
            });
          }
          const errorMsgs = [];
          if (extraData) {
            // pc 端组件层级，直接标错
            extraData.forEach((item) => {
              const state = this.fieldApi.getFieldState(item.id);
              if (state && !state.componentSchema.props.visible) {
                errorMsgs.push(`[隐藏字段] ${item.errorMsg}`);
              } else {
                state.invokeValidate(false, item.errorMsg, item);
              }
            });
            setTimeout(() => {
              this.fieldApi.scrollToErrorField();
              this.scrollManager.updateGroupError({ success: false });
              this.errorManager.updateFormErrors({ validateFieldIdList });
            }, 50);
          }

          reject({
            ...others,
            success: false,
            errorMsg: res.errorMsg
              ? [res.errorMsg].concat(errorMsgs)
              : errorMsgs,
            isBackendError: true,
            response: res,
          });
        })
        .catch((e) => {
          console.error(e);
          govMointor.api(apiPath, false, 0, "fail", JSON.stringify(postData));
          this.scrollManager.updateGroupError({ success: false });
          this.errorManager.updateFormErrors();
          reject({
            success: false,
            errorMsg: ["服务器遇到未知问题，请刷新重试一下"],
            isBackendError: true,
          });
        });
    });
  }
}

export default SubmitManager;
